import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { Map } from 'immutable';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { withTheme, Grid } from '@material-ui/core';
import { FHEContainerForm, FHEItemText, FHEDivider, FormEditButton, FHETextField, FHEReactSelect } from 'data/components';
import { Toastr, tools } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import memoizeOne from 'memoize-one';
import { updateGain, updateProductModule, updateThreshold, updateReversePolarity } from '../../../../../../../data/Products/actions';
import SettingsModal from './SettingsModal';
import FormSettingsButton from '../../../../../../../../../data/components/FormSettingsButton';
import FormDiagnosticButton from '../../../../../../../../../data/components/FormDiagnosticButton';
import DiagnosticModal from './DiagnosticModal';
import FormLiveDataButton from '../../../../../../../../../data/components/FormLiveDataButton';
import LiveDataModal from './LiveDataModal';

class ModulesForm extends Component {
    static propTypes = {
        enumProductModulesTypes: PropTypes.array.isRequired,
        theme: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        moduleType: PropTypes.string,
        productType: PropTypes.string,
        code: PropTypes.string,
        lineType: PropTypes.string,
        label: PropTypes.string,
        favorite: PropTypes.number,
        updateProductModule: PropTypes.func.isRequired,
        match: PropTypes.object.isRequired,
        expanded: PropTypes.string,
        productModulekey: PropTypes.string.isRequired,
        profile: PropTypes.object.isRequired,
        type: PropTypes.string,
        productIdentifier: PropTypes.string.isRequired,
        fheCenter_mac: PropTypes.string,
    };

    static defaultProps = {
        expanded: null,
        moduleType: null,
        productType: null,
        code: null,
        lineType: null,
        label: null,
        favorite: null,
        type: null,
        fheCenter_mac: null,
    };

    constructor(props) {
        super(props);
        this.state = {
            formDisabled: true,
            formThresholdDisabled: true,
            formReversePolarityDisabled: true,
            textInput_error: {},
            sendLoading: false,
            form: {
                moduleType: null,
                label: null,
                favorite: null,
            },
            settingsModalOpen: false,
            diagModalOpen: false,
            liveDataModalOpen: false,
            inelioParamsLoading: false,
        };

        this.favorites = [
            { value: 0, label: Translator.translate('general.productModules.0') },
            { value: 1, label: Translator.translate('general.productModules.1') },
        ];
        this.polarities = [
            { value: 0, label: Translator.translate(`general.productModules.0`) },
            { value: 1, label: Translator.translate('general.productModules.1') },
        ];
    }

    static getDerivedStateFromProps(props, state) {
        const { formDisabled } = state;
        const { moduleType, label, favorite } = props;

        let stateObject = {};

        if (formDisabled) {
            let form = {
                moduleType: state.form.moduleType,
                label: state.form.label,
                favorite: state.form.favorite,
            };
            if (props.moduleType !== state.form.moduleType) {
                form.moduleType = moduleType;
            }
            if (props.label !== state.form.label) {
                form.label = label;
            }
            if (props.favorite !== state.form.favorite) {
                form.favorite = favorite;
            }
            stateObject = {
                ...stateObject,
                form: form,
            };
        }
        return stateObject;
    }

    handleEdit = () => {
        const { formDisabled } = this.state;
        if (formDisabled === true) {
            this.setState({
                formDisabled: false,
                formReversePolarityDisabled: true,
                formThresholdDisabled: true,
            });
        } else {
            this.loadInputs();
        }
    };

    toggleSettingsModalOpen = () => {
        const { settingsModalOpen } = this.state;
        this.setState({
            settingsModalOpen: !settingsModalOpen,
        });
    };

    toggleDiagModalOpen = () => {
        const { diagModalOpen } = this.state;
        this.setState({
            diagModalOpen: !diagModalOpen,
        });
    };

    toggleLiveDataModalOpen = () => {
        const { liveDataModalOpen } = this.state;
        this.setState({
            liveDataModalOpen: !liveDataModalOpen,
        });
    };

    handleEditThreshold = () => {
        const { formThresholdDisabled } = this.state;
        if (formThresholdDisabled === true) {
            this.setState({
                formDisabled: true,
                formReversePolarityDisabled: true,
                formThresholdDisabled: false,
            });
        } else {
            this.loadInputs();
        }
    };

    handleEditReversePolarity = () => {
        const { formReversePolarityDisabled } = this.state;
        if (formReversePolarityDisabled === true) {
            this.setState({
                formDisabled: true,
                formThresholdDisabled: true,
                formReversePolarityDisabled: false,
            });
        } else {
            this.loadInputs();
        }
    };

    handleFormError = (fields, message) => {
        let res = {};
        Object.keys(fields).map(field => {
            fields[field].forEach(error => {
                if (res[field] === undefined) res[field] = [];

                res[field].push(
                    <p key={error} className="mb-1">
                        {Translator.translate(`general.fields.error.${error}`)}
                    </p>,
                );
            });
        });

        this.setState({
            textInput_error: res,
        });

        return Toastr.error(message);
    };

    handleChangeWithVerification = event => {
        const { form, textInput_error } = this.state;
        let targetValue = event.target.type === 'checkbox' ? event.target.checked : event.target.value;

        const fieldLengthRules = {
            label: 255,
        };

        let newTextInput_error = this.removeKey(textInput_error, event.target.name);

        let maxLength = fieldLengthRules[event.target.name];
        if (maxLength && targetValue.length > maxLength) targetValue = form[event.target.name];
        if (targetValue === '') targetValue = null;

        this.setState({
            form: { ...form, [event.target.name]: targetValue },
            textInput_error: newTextInput_error,
        });
    };

    handleChange = event => {
        const { form } = this.state;
        const name = event.target.name;
        let value = event.target.value;

        if (['threshold', 'reversePolarity', 'gain'].includes(name)) {
            if (name === 'reversePolarity') {
                value = parseInt(value);
            }
            this.setState({
                [name]: value,
            });
        } else {
            if (name === 'favorite') {
                value = parseInt(value);
            }
            this.setState({
                form: { ...form, [name]: value },
            });
        }
    };

    isEmpty = value => {
        return value === null || /^\s*$/.test(value);
    };

    loadInputs = () => {
        const { moduleType, label, favorite } = this.props;
        this.setState({
            formDisabled: true,
            textInput_error: {},
            sendLoading: false,
            formThresholdDisabled: true,
            formReversePolarityDisabled: true,
            form: {
                moduleType: moduleType,
                label: label,
                favorite: parseInt(favorite),
            },
        });
    };

    removeKey = (myObj, deleteKey) => {
        return Object.assign(
            {},
            ...Object.entries(myObj)
                .filter(([k]) => k !== deleteKey)
                .map(([k, v]) => ({ [k]: v })),
        );
    };

    formatForm = () => {
        const { form } = this.state;
        let newForm = form;
        Object.keys(newForm).forEach(key => {
            if (newForm[key] === '') {
                newForm[key] = null;
            }
        });
        this.setState({
            form: newForm,
        });
    };

    confirmEdit = () => {
        const { form } = this.state;
        const { updateProductModule, match, code, type, lineType } = this.props;

        this.formatForm();

        if (this.validateForm(form)) {
            this.setState({
                sendLoading: true,
                formDisabled: true,
            });

            return updateProductModule(match.params.homeId, match.params.productIdentifier, match.params.productType, code, form, type, lineType)
                .then(() => {
                    Toastr.success(Translator.translate(`generic.products.actions.editProductModuleSuccess`));
                    this.loadInputs();
                })
                .catch(error => {
                    this.setState({
                        sendLoading: false,
                        formDisabled: false,
                    });
                    Toastr.error(Translator.translate(`generic.products.actions.editProductModuleError`));
                    if (error.validation && error.validation.errors) {
                        return this.handleFormError(error.validation.errors, Translator.translate(`generic.products.actions.editProductModuleError`));
                    }
                });
        }
    };

    validateForm = () => {
        const errors = {};

        this.setState({
            textInput_error: errors,
        });

        return Object.keys(errors).length <= 0;
    };

    getSelectedPolarity = memoizeOne(polarity => {
        return this.polarities.find(x => x.value === polarity);
    });

    getSelectedFavorite = memoizeOne(favorite => {
        return this.favorites.find(x => x.value === favorite);
    });

    getSelectedType = memoizeOne(type => {
        const { enumProductModulesTypes } = this.props;
        return enumProductModulesTypes.find(x => x.value === type);
    });

    handleReactSelect = (event, options) => {
        const { form } = this.state;

        this.setState({
            form: { ...form, [options.name]: event.value },
        });
    };

    setInelioParamsLoading = bool => {
        this.setState({
            inelioParamsLoading: bool,
        });
    };

    render() {
        const {
            enumProductModulesTypes,
            productType,
            code,
            lineType,
            theme,
            expanded,
            productModulekey,
            profile,
            type,
            history,
            productIdentifier,
            fheCenter_mac,
        } = this.props;
        const {
            formDisabled,
            textInput_error,
            sendLoading,
            form,
            settingsModalOpen,
            diagModalOpen,
            inelioParamsLoading,
            liveDataModalOpen,
        } = this.state;

        //const userRightUpdate = profile.get('admin');
        const userRightUpdate = profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('InelioActions');
        const renderEditButton = expanded === productModulekey && userRightUpdate;

        return (
            <Fragment>
                {settingsModalOpen && (
                    <SettingsModal
                        onClose={this.toggleSettingsModalOpen}
                        code={code}
                        product_identifier={productIdentifier}
                        fheCenter_mac={fheCenter_mac}
                        toggleLoading={this.setInelioParamsLoading}
                    />
                )}

                {diagModalOpen && (
                    <DiagnosticModal
                        onClose={this.toggleDiagModalOpen}
                        code={code}
                        product_identifier={productIdentifier}
                        fheCenter_mac={fheCenter_mac}
                    />
                )}

                {liveDataModalOpen && (
                    <LiveDataModal
                        onClose={this.toggleLiveDataModalOpen}
                        code={code}
                        product_identifier={productIdentifier}
                        fheCenter_mac={fheCenter_mac}
                    />
                )}

                {renderEditButton && (
                    <Fragment>
                        <FormEditButton
                            useSecondaryPosition
                            formDisabled={formDisabled}
                            handleEdit={this.handleEdit}
                            confirmEdit={this.confirmEdit}
                            sendLoading={sendLoading}
                        />
                        {formDisabled && (
                            <Fragment>
                                <FormSettingsButton
                                    formDisabled={formDisabled}
                                    sendFunc={this.toggleSettingsModalOpen}
                                    sendLoading={inelioParamsLoading}
                                />
                                <FormDiagnosticButton formDisabled={formDisabled} sendFunc={this.toggleDiagModalOpen} />
                                <FormLiveDataButton formDisabled={formDisabled} sendFunc={this.toggleLiveDataModalOpen} />
                            </Fragment>
                        )}
                    </Fragment>
                )}

                <FHEContainerForm withoutPadding>
                    <Grid container spacing={3}>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHETextField
                                disabled={formDisabled}
                                id="label"
                                value={!form.label || form.label === null ? '' : form.label}
                                error={textInput_error.label}
                                label={Translator.translate('general.table.column.label')}
                                name="label"
                                onChange={this.handleChangeWithVerification}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEReactSelect
                                name="moduleType"
                                label={Translator.translate('general.table.column.moduleType')}
                                disabled={formDisabled}
                                onChange={this.handleReactSelect}
                                value={this.getSelectedType(form.moduleType)}
                                choices={enumProductModulesTypes}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEReactSelect
                                name="favorite"
                                label={Translator.translate('general.table.column.favorite')}
                                disabled={formDisabled}
                                onChange={this.handleReactSelect}
                                value={this.getSelectedFavorite(form.favorite)}
                                choices={this.favorites}
                            />
                        </Grid>
                    </Grid>
                    <FHEDivider color={theme.palette.colors.grey100} />
                    <Grid container spacing={3}>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEItemText
                                itemTitle={Translator.translate('general.table.column.productType')}
                                itemContent={Translator.translate(`general.productModules.${productType}`)}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEItemText
                                itemTitle={Translator.translate('general.table.column.lineType')}
                                itemContent={Translator.translate(`general.productModules.${lineType}`)}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEItemText itemTitle={Translator.translate('general.table.column.code')} itemContent={code} />
                        </Grid>
                    </Grid>
                </FHEContainerForm>
            </Fragment>
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    const productKey = props.productKey;
    const productModulekey = props.productModulekey;
    const product = state.environments[history.environment].data.Products.getIn(['list', productKey], new Map());
    let productModule = new Map();
    if (state.environments[history.environment].data.Products.getIn(['list', productKey, 'productModules'])) {
        productModule = state.environments[history.environment].data.Products.getIn(
            ['list', productKey, 'productModules', productModulekey],
            new Map(),
        );
    }
    let fheCenter_mac = null;
    state.environments[history.environment].data.Boxes.get('list').map((box, macAddress) => {
        if (box.get('homeId') === productModule.get('homeId')) fheCenter_mac = macAddress;
    });
    const enums = state.environments[history.environment].enums;
    return {
        enumProductModulesTypes: enums.productModulesTypes || [],
        profile: state.data.user,
        type: product.get('type'),
        imageName: productModule.get('imageName'),
        moduleType: productModule.get('moduleType'),
        productType: productModule.get('productType'),
        threshold: productModule.get('threshold'),
        gain: productModule.get('value'),
        code: props.line.get('code', ''),
        lineType: productModule.get('lineType'),
        reversePolarity: productModule.get('reversePolarity'),
        label: productModule.get('label'),
        productIdentifier: props.line.get('productIdentifier', ''),
        favorite: productModule.get('favorite'),
        productModulekey,
        fheCenter_mac,
    };
}

export default withRouter(
    renderEnvComponent(
        'scenes/Products/components/ProductModule/ModulesForm/index',
        connect(
            mapStateToProps,
            (dispatch, ownProps) =>
                bindActionCreators(
                    tools.mergePropsToAction(ownProps.history.environment, {
                        updateGain,
                        updateProductModule,
                        updateThreshold,
                        updateReversePolarity,
                    }),
                    dispatch,
                ),
        )(withTheme(ModulesForm)),
    ),
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Products/components/Product/Fhe/SDM19INL/components/ModulesForm.js